// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScreenTrend_wrapper__1TFuD"};